import React, {useState, useEffect} from 'react';
import { DataTableComp } from "../Common/DataTable";
import Header from "../Header/Header";
import { Layout } from "../Layout/Layout";
import Switch from '@mui/material/Switch';
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'
import { IconButton, Tooltip } from '@mui/material';
import { Delete, Edit, RemoveRedEye } from '@mui/icons-material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const label = { inputProps: { 'aria-label': 'Color switch demo' } };

export default function EmailTemplate() {
    const [emailTemplates, setEmailTemplates] = useState([]);
    const navigate = useNavigate();
    const authUser = localStorage.getItem('FF-authUser');
    const user = JSON.parse(authUser);

    useEffect(() => {
        getList();
    }, [])

    const getList = async() => {
        await axios.get(`/api/email_templates`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setEmailTemplates(result.data)
            }
        })
    }

    const handleEdit = (id, isSuperAdmin) => {
        isSuperAdmin ? navigate('/edit_email_template/'+id+'?copy=yes') : navigate('/edit_email_template/'+id)
    }

    const handleView = (id) => {
        navigate('/view_email_template/'+id)
    }

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure you want to delete?',
            showCancelButton: true,
            confirmButtonColor: '#45a7c4',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) { 
                axios.delete(`/api/email_templates/delete?id=${id}`).then((res) =>{
                    if(res.data.success){                             
                        Swal.fire(res.data.message, '', 'success')
                        getList();
                    } 
                }).catch((error) => {
                    console.log(error);                     
                    Swal.fire(error.message, '', 'info')           
                });
            } else if (result.isDenied) {
              Swal.fire('Cancelled!', '', 'info')
            }
        }) 
    }

    const handleStatus = (e, id) => { 
        var status = e.target.checked === true ? '1' : '0';
        axios.put(`api/email_templates/updateStatus?id=${id}`, {status}).then(res => {
            if(res.data.success){                             
                Swal.fire(res.data.message, '', 'success')
            }
            else{
                Swal.fire(res.data.message, '', 'error')
            }                
        })
        .catch(err => {
            Swal.fire('Try Again!', '', 'error')
        })
    }
    
    const columns = [
        {
            name: 'Template Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Status',
            cell: row => (
               <Switch className="Rj-toggle" {...label} defaultChecked={row.status === '1' ? true : false} color="info" onChange={(e) => handleStatus(e, row.id)}/>                
            )
        },
        {
            name: 'Action',
            cell: row => (
                row.userId === user.id ?
                <>                    
                    <Tooltip onClick={() => handleEdit(row.id, false)} title="Edit" size='small' className='icon icon-sm icon-secondary'>
                        <IconButton>
                             <Edit />
                        </IconButton>
                    </Tooltip>
                    <Tooltip onClick={() => handleDelete(row.id)} title="Delete" size='small' className='icon icon-sm icon-primary ms-2'>
                        <IconButton>
                            <Delete />
                        </IconButton>
                    </Tooltip>
                </>
                : 
                <>
                    <Tooltip onClick={() => handleView(row.id)} title="View" size='small' className='icon icon-sm icon-secondary'>
                        <IconButton>
                            <RemoveRedEye />
                        </IconButton>
                    </Tooltip>
                    <Tooltip onClick={() => handleEdit(row.id, true)} title="Copy" size='small' className='icon icon-sm icon-primary ms-2'>
                        <IconButton>
                            <ContentCopyIcon />
                        </IconButton>
                    </Tooltip>
                </>
            )
        }
    ];
    return(
        <Layout>
            <Header pageTitle="Users" />
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h3 className="fw-bold mb-0">Email Templates</h3>
                        <div>
                            <Link to="/add_email_template" className="btn btn-primary ms-2">
                                <span className="tf-icons bx bx-plus"></span>&nbsp; Add Email Template
                            </Link>
                        </div>
                    </div>
                    <div className="table text-nowrap">
                        <div className="">
                            <DataTableComp columns={columns} data={emailTemplates} isIndex={true} />                            
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}